//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"EnumFilter",1,0]],[[["ldObject"],"Hide",{},1,0],[["ldObject"],"Unhide",{},1,0],[["ldObject"],"CreateEngineeringObjectAndMap",{R_:{mappedObject:"NXObject"}},1,0],[["ldObjects","nADObjects"],"CreateEngineeringObjectAndMap1",{R_:{adObjects:"NXObject[]"}},1,0]],[]];
SPLM.AME.LineDesignerMappingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.LineDesignerMappingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.LineDesignerMappingBuilder.FilterType = Object.freeze({
    "Unhidden" : "Unhidden", "Hidden" : "Hidden", "Unmapped" : "Unmapped", "Mapped" : "Mapped", "Deleted" : "Deleted", "TypeMapped" : "TypeMapped", "All" : "All"});

export default SPLM;